import React from "react";
import { Grid, TextField } from "@mui/material";

const GoalsAndLifestyle = ({ formData, handleInputChange }) => {
  return (
    <>
      <Grid item xs={12}>
        <TextField
          label="Objectifs Fitness"
          name="objectifsFitness"
          value={formData.objectifsFitness}
          onChange={handleInputChange}
          fullWidth
          multiline
          rows={2}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Fréquence d'entraînement"
          name="frequenceEntrainement"
          value={formData.frequenceEntrainement}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Profession"
          name="profession"
          value={formData.profession}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Pathologies / Blessures"
          name="pathologiesBlessures"
          value={formData.pathologiesBlessures}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Régime Spécial"
          name="regimeSpecial"
          value={formData.regimeSpecial}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Substances PED"
          name="substancesPED"
          value={formData.substancesPED}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
    </>
  );
};

export default GoalsAndLifestyle;
